function Footer() {
  return (
    <div className="home__footer">
      <p>@ {new Date().getFullYear()}. All rights reserved.</p>
    </div>
  );
}

export default Footer;
